// extracted by mini-css-extract-plugin
module.exports = {"Container":"Footer_Container__2PC_F","NextLabel":"Footer_NextLabel__36Mei"};